/**
 * @Name: 酒店资源配置 store
 */
import services from '../../services'

const state = {
    hotelResourcesList: [], // 酒店资源列表
    bookingHotelPageList: [], // 酒店列表数据
    pageVObookingHotelPageList: {
        curPage: 1,
        pageSize: 10,
        totalRows: 0
    },
    bussnessHotelList: [], // 商旅酒店房型数据
    hotelList: {}, // 商旅选择酒店数据
    roomTypeList: [],
    hotelRule: {}
}

const getters = {
}
const actions = {

    /**
     * 获取酒店资源列表数据
     * @param {*} context
     * @param {*} param
     */
    getHotelResourcesList(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getHotelResourcesList(param).then((res) => {
                context.commit('setHotelResourcesList', res.data || {})
                resolve()
            })
        })
    },
    findBookingHotelPageList(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.getBusinessHotelList(param).then((res) => {
                resolve(res.data)
            })
        })
    },

    /**
     * 商旅酒店房型数据
     */
    getBusinessHotelRoomList(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.getBusinessHotelRoomList(param).then((res) => {
                resolve(res.data)
            })
        })
    },

    /**
     * 排队校验
     */
    checkQueuing(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.checkQueuing(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 获取团组信息
     */
    findGroupInfo(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.findGroupInfo(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 新增商旅提交预定
     */
    addBusinessOrder(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.addBusinessOrder(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 修改商旅提交预定
     */
    updateBusinessOrderAct(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.updateBusinessOrder(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 酒店规则
     */
    getHotelRule(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.getHotelRule(param).then((res) => {
                context.commit('setHotelRule', res.data.data || {})
                resolve(res && res.data && res.data.data)
            })
        })
    },

    /**
     * 酒店规则
     */
    checkSingleRoomCount(context, param) {
        return new Promise((resolve, reject) => {
            services.businessConfigSer.checkSingleRoomCount(param).then((res) => {
                resolve(res)
            })
        })
    }
}
const mutations = {

    /**
     * 设置酒店资源列表数据
     * @param {*} state
     * @param {*} payload
     */
    setHotelResourcesList(state, payload) {
        state.hotelResourcesList = payload
    },

    /**
     * 商旅添加酒店列表选择
     */
    setBookingHotelPageList(state, payload) {
        payload.data && (state.bookingHotelPageList = payload.data)
        payload.pageInfo && (state.pageVObookingHotelPageList = payload.pageInfo)
    },

    /**
     * 商旅房型数据
     */
    setBusinessHotelRoomList(state, payload) {
        if (payload && payload.length === 0) {
            return false
        }
        // 商旅房型数据需要把酒店规则放入数据中
        payload.data.forEach(info => {
            info.noshowEndDate = state.hotelRule.noshowEndDate && state.hotelRule.noshowEndDate.substr(0, 10)
            info.custStayMax = state.hotelRule.custStayMax
            info.selRoomNum = 0
            info.flagType = false
        })
        state.bussnessHotelList = payload.data
    },

    /**
     * 商旅预定选择酒店参数
     */
    selectHotelList(state, payload) {
        state.hotelList = payload
    },

    /**
     * 选择房型数据
     */
    selectRoomTypeList(state, payload) {
        state.roomTypeList = payload
    },

    /**
     * 酒店规则数据
     */
    setHotelRule(state, payload) {
        state.hotelRule = payload
    }

    /** ============================= 新增酒店 ============================= **/
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
